/** @param {string} s */
function stripDiacritics(s) {
  return s.normalize('NFD').replace(/\p{M}/gu, '');
}

/**
 * @param {unknown} raw
 */
export function normalizeRowAdCategoryKey(raw) {
  const s = stripDiacritics(String(raw ?? '').trim().toLowerCase());
  if (!s) return '';
  return s.replace(/\s+/g, '_').replace(/_+/g, '_');
}

const CANONICAL_SLUGS = new Set([
  'news',
  'sports',
  'movies',
  'series',
  'kids',
  'international',
  'exclusive',
  'premium',
  'all',
  'every_categories',
  'most_watched',
]);

const ALIAS_ENTRIES = [
  ['sports', 'sports'],
  ['sport', 'sports'],
  ['esportes', 'sports'],
  ['esporte', 'sports'],
  ['deportes', 'sports'],
  ['deporte', 'sports'],
  ['movies', 'movies'],
  ['movie', 'movies'],
  ['filmes', 'movies'],
  ['filme', 'movies'],
  ['peliculas', 'movies'],
  ['cine', 'movies'],
  ['cinema', 'movies'],
  ['series', 'series'],
  ['seriesandshows', 'series'],
  ['series_y_shows', 'series'],
  ['news', 'news'],
  ['localandnews', 'news'],
  ['local_and_news', 'news'],
  ['noticias', 'news'],
  ['Locais & Notícias', 'news'],
  ['Locais e Noticias', 'news'],
  ['Locales & Noticias', 'news'],
  ['Locales y Noticias', 'news'],
  ['localAndNews', 'news'],
  ['international', 'international'],
  ['internationals', 'international'],
  ['internacional', 'international'],
  ['exclusive', 'exclusive'],
  ['exclusives', 'exclusive'],
  ['exclusivos', 'exclusive'],
  ['premium', 'premium'],
  ['kids', 'kids'],
  ['kid', 'kids'],
  ['infantil', 'kids'],
  ['most_watched', 'most_watched'],
  ['mostwatched', 'most_watched'],
  ['all', 'all'],
  ['todos', 'all'],
  ['every_categories', 'every_categories'],
  ['everycategories', 'every_categories'],
];

const ALIAS_TO_CANONICAL = new Map(
  ALIAS_ENTRIES.map(([alias, canonical]) => [normalizeRowAdCategoryKey(alias), canonical]),
);

/**
 * @param {unknown} raw
 * @returns {string|null} slug ou null se não mapeado
 */
export function normalizeRowAdApiCategory(raw) {
  const key = normalizeRowAdCategoryKey(raw);
  if (!key) {
    return null;
  }
  if (ALIAS_TO_CANONICAL.has(key)) {
    return ALIAS_TO_CANONICAL.get(key);
  }
  if (CANONICAL_SLUGS.has(key)) {
    return key;
  }
  return null;
}
